import api from './api';
import { Customer } from '../types';

interface DependencyCheck {
  canDelete: boolean;
  reasons: string[];
}

export const customersService = {
  getAll: async (isActive?: boolean, includeDeleted?: boolean): Promise<Customer[]> => {
    const params: any = {};
    if (isActive !== undefined) params.isActive = isActive;
    if (includeDeleted) params.includeDeleted = true;
    const response = await api.get<Customer[]>('/customers', { params });
    return response.data;
  },

  getById: async (id: string): Promise<Customer> => {
    const response = await api.get<Customer>(`/customers/${id}`);
    return response.data;
  },

  create: async (data: Partial<Customer>): Promise<Customer> => {
    const response = await api.post<Customer>('/customers', data);
    return response.data;
  },

  update: async (id: string, data: Partial<Customer>): Promise<Customer> => {
    const response = await api.patch<Customer>(`/customers/${id}`, data);
    return response.data;
  },

  checkDependencies: async (id: string): Promise<DependencyCheck> => {
    const response = await api.get<DependencyCheck>(`/customers/${id}/check-dependencies`);
    return response.data;
  },

  // Soft delete (archive)
  delete: async (id: string): Promise<void> => {
    await api.delete(`/customers/${id}`);
  },

  // Restore from archive
  restore: async (id: string): Promise<Customer> => {
    const response = await api.post<Customer>(`/customers/${id}/restore`);
    return response.data;
  },

  // Permanent delete
  permanentDelete: async (id: string): Promise<void> => {
    await api.delete(`/customers/${id}/permanent`);
  },
};
